const i="wix-draft-plugin-link-preview";export{i as LINK_PREVIEW_TYPE};
//# sourceMappingURL=types.js.map
